/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormState } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { convertCurrency } from '../../../../misc/ecbCurrencyRates';
import SwitchComponent from '../SwitchComponent';
import InputField from '../../../../elements/InputField';
import DoubleCurrencyField from './components/DoubleCurrencyField';
import FxRateApply from './components/FxRateApply';
import products from '../products';
import templateFieldNames from './templateFieldNames';

dayjs.extend(utc);

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function Step3Contributions({ index, updateWorkflowStatus, form, signalNext, setSignalNext }) {
  const { t: tL } = useTranslation('app', { keyPrefix: 'schema.pension.account' });
  const { t: tI } = useTranslation('addAccount', { keyPrefix: 'pension' });
  const baseCurrency = useSelector((state) => state.user.profile.settings.baseCurrency);
  const [fxRate, setFxRate] = useState(null);

  const { register, watch, getValues, control, setValue, trigger } = form;
  const { errors, isValid } = useFormState({
    control,
    name: [
      'contributionsSelfPaid',
      'contributionsAmountsUserInput',
      'contributionsAmountsUserInputBaseCurrency',
      'contributionsDeductible',
      'contributionsIndexed',
      'discountRateIsInflation',
      'customDiscountRate',
    ],
  });
  const contributionsSelfPaid = watch('contributionsSelfPaid');
  const contributionsIndexed = watch('contributionsIndexed');
  const discountRateIsInflation = watch('discountRateIsInflation');
  const watchedCurrency = watch('currency');
  const accountCurrency = watchedCurrency || baseCurrency;
  const isBaseCurrencySameAsAccountCurrency = getValues('isBaseCurrencySameAsAccountCurrency'); // set in step 1

  const TAB_STOPS = {
    contributionsSelfPaid: 1,
    contributionsAmountsAccount: 2,
    contributionsAmountsBase: 3,
    contributionsDeductible: 4,
    contributionsIndexed: 5,
    discountRateIsInflation: 6,
    customDiscountRate: 7,
    applyFxRate: 8,
  };

  //--------------------------------------------------------------------------------
  // subscribe to signal from parent that the user has clicked the "next" button
  // (and then trigger all validations to show errors)
  //--------------------------------------------------------------------------------

  useEffect(() => {
    if (signalNext) {
      trigger();
      setSignalNext(false);
    }
  }, [signalNext, trigger, setSignalNext]);

  useEffect(() => {
    async function updateFxRate() {
      if (!accountCurrency || !baseCurrency) return;
      if (isBaseCurrencySameAsAccountCurrency) {
        setFxRate(null);
        return;
      }
      setFxRate('loading');
      try {
        const newRate = await convertCurrency(1, accountCurrency, baseCurrency, dayjs.utc().startOf('day').valueOf());
        setFxRate(newRate);
      } catch (err) {
        setFxRate(null);
      }
    }
    updateFxRate();
  }, [accountCurrency, baseCurrency, isBaseCurrencySameAsAccountCurrency]);

  useEffect(() => {
    updateWorkflowStatus(index, isValid);
  }, [isValid]);

  useEffect(() => {
    if (!contributionsIndexed) {
      setValue('discountRateIsInflation', null, { shouldDirty: false, shouldValidate: true });
      setValue('customDiscountRate', null, { shouldDirty: false, shouldValidate: true });
      return;
    }

    if (discountRateIsInflation === undefined || discountRateIsInflation === null) {
      setValue('discountRateIsInflation', true, { shouldDirty: false, shouldValidate: true });
    }
    if (discountRateIsInflation) {
      setValue('customDiscountRate', null, { shouldDirty: false, shouldValidate: true });
    }
  }, [contributionsIndexed, discountRateIsInflation, setValue]);

  //---------------------------------------------------------------------------------------------
  // set product to "custom" if the user changes any of the connected fields
  //---------------------------------------------------------------------------------------------

  // icon and id are in products, need to add the translations here
  const productList = products.pension.map((p) => ({
    ...p,
    name: tI(`product.${p.id}.name`),
    description: tI(`product.${p.id}.description`),
  }));

  const product = watch('product'); // this field's value is the product ID
  const severalSetValueInProgress = React.useRef(false); // to avoid the next useEffect to trigger immediatelly after the first setValue

  // watch all fields determined by a pension template array members
  const templateFieldsValues = watch(templateFieldNames); // this destructures to an array, i.e. const [value1, value2] = watch(['field1', 'field2'])

  // if the product is not on "custom" and the user changes any connected form fields, "product" should be reset to "custom"
  useEffect(() => {
    if (product && product !== 'custom' && !severalSetValueInProgress.current) {
      // if a defined product is selected, check if all product fields in the state are equal to the template fields
      const selectedProduct = productList.find((p) => p.id === product);
      // console.log('handler for >custom< is running for product', product, 'selectedProduct', selectedProduct, 'templateFieldsValues', templateFieldsValues, 'getValues', getValues());
      const allFieldsEqual = templateFieldsValues.every((value, idx) => {
        const fieldName = templateFieldNames[idx];
        // console.log('comparing form state field', fieldName, value, 'with product template field value', selectedProduct[fieldName]);
        return value === selectedProduct[fieldName];
      });
      if (!allFieldsEqual) setValue('product', 'custom');
    }
  }, [templateFieldsValues]);

  const handleFxRateButton = () => {
    if (!Number.isFinite(fxRate) || isBaseCurrencySameAsAccountCurrency) return;
    const amount = Number(getValues('contributionsAmountsUserInput'));
    if (Number.isNaN(amount)) return;
    setValue('contributionsAmountsUserInputBaseCurrency', Number((amount * fxRate).toFixed(2)), { shouldDirty: true, shouldValidate: true });
  };

  //---------------------------------------------------------------------------------------------
  // render the form
  //---------------------------------------------------------------------------------------------

  return (
    <div className="pt-4 sm:pt-0">
      <h3 className="text-xl md:text-2xl font-bold leading-6 text-gray-900">{tI('wizardSteps.contributions.title')}</h3>
      <p className="mt-1 pb-4 text-sm text-gray-500">{tI('wizardSteps.contributions.subtitle')}</p>

      <div className="py-3 lg:pb-4 grid grid-cols-1 xs:grid-cols-2 gap-4 xs:gap-6 lg:gap-8">
        <Controller
          name="contributionsSelfPaid"
          control={control}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <SwitchComponent
              id="contributionsSelfPaid"
              formatting="col-span-full xs:col-span-1 xs:col-start-1"
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              inputRef={ref}
              tabIndex={TAB_STOPS.contributionsSelfPaid}
              label={tL('contributionsSelfPaid.label')}
              tooltip={tL('contributionsSelfPaid.tooltip')}
            />
          )}
        />
        <DoubleCurrencyField
          accountField="contributionsAmountsUserInput"
          baseField="contributionsAmountsUserInputBaseCurrency"
          label={tL('contributionsAmounts.label')}
          tooltip={tL('contributionsAmounts.tooltip')}
          optionalText={contributionsSelfPaid ? '' : 'Optional'}
          placeholderAccount={tL('contributionsAmounts.placeholder')}
          placeholderBase={tL('contributionsAmounts.placeholder')}
          errors={errors}
          register={register}
          watch={watch}
          accountCurrency={accountCurrency}
          isBaseCurrencySameAsAccountCurrency={isBaseCurrencySameAsAccountCurrency}
          baseCurrency={baseCurrency}
          className="col-span-full xs:col-span-1 xs:col-start-2"
          accountTabIndex={TAB_STOPS.contributionsAmountsAccount}
          baseTabIndex={TAB_STOPS.contributionsAmountsBase}
          accountValidation={{
            validate: (value) => (contributionsSelfPaid === true && !value ? tL('contributionsAmounts.error') : true),
          }}
          baseValidation={
            isBaseCurrencySameAsAccountCurrency
              ? undefined
              : {
                validate: (value) => (contributionsSelfPaid === true && !value ? tL('contributionsAmounts.error') : true),
              }
          }
        />
        <Controller
          name="contributionsDeductible"
          control={control}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <SwitchComponent
              id="contributionsDeductible"
              formatting="col-span-full xs:col-span-1 xs:col-start-1"
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              inputRef={ref}
              tabIndex={TAB_STOPS.contributionsDeductible}
              label={tL('contributionsDeductible.label')}
              tooltip={tL('contributionsDeductible.tooltip')}
            />
          )}
        />
        <Controller
          name="contributionsIndexed"
          control={control}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <SwitchComponent
              id="contributionsIndexed"
              formatting="col-span-full xs:col-span-1 xs:col-start-1"
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              inputRef={ref}
              tabIndex={TAB_STOPS.contributionsIndexed}
              label={tL('contributionsIndexed.label')}
              tooltip={tL('contributionsIndexed.tooltip')}
            />
          )}
        />
        {contributionsIndexed && (
          <Controller
            name="discountRateIsInflation"
            control={control}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <SwitchComponent
                id="discountRateIsInflation"
                formatting="col-span-full xs:col-span-1 xs:col-start-2"
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                inputRef={ref}
                tabIndex={TAB_STOPS.contributionsIndexedByInflation}
                label={tL('discountRateIsInflation.label')}
                tooltip={tL('discountRateIsInflation.tooltip')}
              />
            )}
          />
        )}
        {contributionsIndexed && discountRateIsInflation === false && (
          <InputField
            id="customDiscountRate"
            category="pension"
            type="number"
            autoComplete="off"
            optional={false}
            register={register}
            errors={errors}
            formatting="col-span-full xs:col-span-1 xs:col-start-1"
            validationRules={{
              validate: (value) => (value !== undefined && value !== null && value !== '' ? true : tL('customDiscountRate.error')),
            }}
          />
        )}
        {!isBaseCurrencySameAsAccountCurrency && (
          <FxRateApply
            fxRate={Number(fxRate)}
            labelText={tL('fxRate.label', { accountCurrency, baseCurrency })}
            tooltipText={tL('fxRate.tooltip', { baseCurrency })}
            buttonText={tL('fxRate.apply', { baseCurrency })}
            onApply={handleFxRateButton}
            className="col-span-full xs:col-span-1"
            tabIndex={TAB_STOPS.applyFxRate}
          />
        )}
        {' '}
      </div>
    </div>
  );
}

Step3Contributions.propTypes = {
  index: PropTypes.number.isRequired,
  updateWorkflowStatus: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  signalNext: PropTypes.bool,
  setSignalNext: PropTypes.func,
};
Step3Contributions.defaultProps = {
  signalNext: undefined,
  setSignalNext: () => {},
};

export default Step3Contributions;
